var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalGroupIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_87823",
    "data-name": "Group 87823",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14977",
    "data-name": "Rectangle 14977",
    width: 27,
    height: 27,
    rx: 7,
    fill: "#e2eeff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "customer",
    transform: "translate(5.074 6.148)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1525",
    "data-name": "Ellipse 1525",
    cx: 2.81,
    cy: 2.872,
    rx: 2.81,
    ry: 2.872,
    transform: "translate(5.62)",
    fill: "#024fd1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1526",
    "data-name": "Ellipse 1526",
    cx: 1.811,
    cy: 1.811,
    r: 1.811,
    transform: "translate(12.364 2.123)",
    fill: "#024fd1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1527",
    "data-name": "Ellipse 1527",
    cx: 1.811,
    cy: 1.811,
    r: 1.811,
    transform: "translate(0.874 2.123)",
    fill: "#024fd1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106388",
    "data-name": "Path 106388",
    d: "M4.417,241.038a2.927,2.927,0,0,0-2.182-.507A2.231,2.231,0,0,0,0,242.753v3.595a.967.967,0,0,0,.968.964c2.3,0,2.027.042,2.027-.1C3,244.665,2.694,242.8,4.417,241.038Z",
    transform: "translate(0 -233.685)",
    fill: "#024fd1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106389",
    "data-name": "Path 106389",
    d: "M125.438,239.889a4.887,4.887,0,0,0-3.769.892c-1.806,1.446-1.458,3.394-1.458,5.776a1.155,1.155,0,0,0,1.153,1.153c6.948,0,7.224.224,7.636-.688.135-.309.1-.21.1-3.162A3.99,3.99,0,0,0,125.438,239.889Z",
    transform: "translate(-116.229 -233.029)",
    fill: "#024fd1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106390",
    "data-name": "Path 106390",
    d: "M379.992,240.533a2.925,2.925,0,0,0-2.182.507c1.71,1.746,1.422,3.487,1.422,6.174,0,.142-.23.1,1.993.1a1,1,0,0,0,1-1v-3.56A2.231,2.231,0,0,0,379.992,240.533Z",
    transform: "translate(-365.375 -233.687)",
    fill: "#024fd1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalGroupIcon);
export default __webpack_public_path__ + "static/media/total_group_icon.10023001.svg";
export { ForwardRef as ReactComponent };